<template>
    <div class="mr-1 mb-10 mt-0">
        <div class="p-5 position-content-main">
            <div class="breadcrumbnewtheme pb-3">
                <div class="pre gap-0p5 fw-500">
                    Settings
                </div>
                <span style="color:#b2bec3">/</span>
                <div class="pre gap-0p5 fw-500">
                    Templates
                </div>
                <!-- <span style="color:#b2bec3">/</span>
                <div class="pre gap-0p5 fw-500">
                    List View
                </div> -->
                <span style="color:#b2bec3">/</span>
                <span class="curr gap-0p5 fw-500">
                    Create New
                </span>
            </div>
            <div class="template-list-main-container mt-4">
                <div>
                    <div v-if="is_api_calling" class="checkoutLoader">
                        <div class="LoaderPlacement">
                                <div class="digi-table-loader">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                        </div>
                    </div>
                    <div>
                        <div class="template-list-main-container-inner px-4" v-if="initial_template_data.template_type == 'multi_part'">
                            <span class="fs-16 text-black fw-500">Template: {{initial_template_data.name || '-'}}</span>
                            <p class="fs-12 text-black mt-2 ">Part 2: Add required Fields to Template</p>
                            <div class="mt-4">
                                <!-- <img src="/static/images/layout-top-2-line.svg" alt="layout-top" width="19px"> -->
                                <span class="pl-4 pb-2 parts-container" style="border-bottom: 0.3px solid rgba(19, 14, 14, 0.2) !important">
                                    <span v-for="(part, part_index) in initial_template_data.multi_parts_data" :key="part_index"  :class="part_index < selected_index ? 'color-success' : part_index > selected_index ? 'color-grey' : 'color-secondary'" class="fs-16 text-capitalize color-light-blue fw-500 part-item">
                                        <span class=" mr-2" :class="part_index < selected_index ? 'icon icon-check-circle-outline text-success ' : part_index > selected_index ? ' index-circle text-black' : 'index-circle bg-secondary-custom'" >
                                            <!-- <span class="icon icon-check-circle text-success " v-if="part_index < selected_index"></span> -->
                                             <span v-if="part_index >= selected_index"> {{ part_index + 1}}</span>
                                        </span> <span class="text-black" :class="part_index < selected_index ? 'color-success' : part_index > selected_index ? 'text-black' : 'highlighted-black'"> {{part.name}}</span>
                                    </span>

                                </span>
                            </div>
                        </div>
                        <div class="template-list-inner-content template-list-main-container-inner mt-3" >
                            <!-- Multi Part -->
                            <div class="mt-0" v-if="initial_template_data.template_type == 'multi_part'">
                                <div v-for="(part, part_index) in initial_template_data.multi_parts_data" :key="part_index">
                                    <div class="d-flex mb-5" v-if="selected_index == part_index">
                                        <div class="text-nowrap text-black fs-20 fw-600 caps">{{part_index +1}}.{{part.name}}</div> 
                                        <!-- <div class="w-100 ml-2" style="border-bottom:1px solid #a5a5a5;margin-bottom:10px"></div> -->
                                    </div>
                                    <div v-if="selected_index == part_index">
                                        <div v-for="(que_data, all_questions_index) in part.fields" :key="all_questions_index+'dd'">
                                            <div class="d-flex mt-3">
                                                <div class="template-list-question-box w-100">
                                                    <div class="row d-flex flex-lg-row">
                                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                                            <div class="w-100" style="position: relative;">
                                                                <!-- @input="findDulplicatesquestions('multi_part')" -->
                                                                <input class="newInputField inputFieldNew-padding" maxlength="200" v-validate="selected_index == part_index ? 'required' : ''" :name="'question'+all_questions_index" data-vv-as="Question"  v-model="que_data.name" type="text" autocomplete="off" placeholder="Enter Question" />
                                                                <span class="inputBorder"></span>
                                                                <span class="invalid-feedback-form text-danger mt-1 ml-3 position-absolute" v-show="errors.has('question'+all_questions_index)">{{errors.first('question'+all_questions_index)}}</span>
                                                                <span class="invalid-feedback-form text-danger mt-1 ml-3 position-absolute" :class="errors.has('question'+all_questions_index) ? 'top-57px' : ''" v-show="que_data.is_questions_duplicate">The Questions must be Unique</span>
                                                                <div class="text-right fs-14 mt-1">{{200 - que_data.name.length}}/200</div>
                                                                <el-checkbox class="ml-2" @change="ToggleAttachment($event, que_data)" v-model="que_data.add_attachments">Add Attachments</el-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-4 col-md-6 col-sm-12">
                                                            <div class="form-group contactGroup pt-2">
                                                                <div class="">
                                                                    <multiselect
                                                                        class="diginew-multiselect down-arrow mt-1"
                                                                        v-model="que_data.type"
                                                                        :options="type_options"
                                                                        :searchable="true"
                                                                        :name="'type'+all_questions_index"
                                                                        :close-on-select="true"
                                                                        v-validate="selected_index == part_index ? 'required' : ''"
                                                                        :show-labels="false"
                                                                        data-vv-as="Type"
                                                                        placeholder="Choose Field Type"
                                                                        internal-search="true"
                                                                    >
                                                                        <template slot="noResult">
                                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                        </template>
                                                                    </multiselect>
                                                                </div>
                                                                <span class="invalid-feedback-form text-danger mt-1" v-show="errors.has('type'+all_questions_index)">{{errors.first('type'+all_questions_index)}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row align-items-end">
                                                        <div class="col-lg-8 col-md-8 col-sm-12">
                                                            <!-- Radio Button -->
                                                            <div v-if="que_data.type == 'Radio Button' || que_data.type == 'radio_button'" class="d-flex form-check form-check-inline">
                                                                <div v-for="(radio_btn, radio_btn_index) in que_data.possible_values" :key="radio_btn_index">
                                                                    <label class="form-check-label position-relative mt-3 ml-5">
                                                                        <input class="form-check-input" :disabled="true" style="top: 5px;left: -5px;width: 20px;height: 20px;" type="radio"
                                                                            value="option 1">
                                                                        <span class="radio-icon" style="width: 20px;height: 20px; top: -4px;left: -20px;"></span>
                                                                        <input type="text" maxlength="15" v-model="que_data.possible_values[radio_btn_index]" 
                                                                            v-validate="selected_index == part_index ? 'required' : ''" data-vv-as="Option" @input="findDulplicatesoptions('multi_part', que_data)"
                                                                            :name="'radio_options'+all_questions_index+''+radio_btn_index" :placeholder="'Option '+(radio_btn_index+1)" 
                                                                            class="input-border-bottom pb-0" style="width: 200px !important; border-bottom: solid 2px #0d84f2 !important;" />
                                                                        <i :class="{'icon-delete-opacity-show':radio_btn_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteMultiPartOptions(all_questions_index, radio_btn_index, part_index)"></i>
                                                                        <i v-if="(que_data.possible_values.length - 1 == radio_btn_index) && (que_data.possible_values.length < 50)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('radio_btn_option', all_questions_index, radio_btn_index, part_index)"></i>
                                                                    </label>
                                                                    <span class="invalid-feedback-form text-danger ml-3 position-absolute" v-show="errors.has('radio_options'+all_questions_index+''+radio_btn_index)">{{errors.first('radio_options'+all_questions_index+''+radio_btn_index)}}</span>
                                                                    <div class="text-right fs-14">{{15 - que_data.possible_values[radio_btn_index].length}}/15</div>
                                                                </div>
                                                            </div>

                                                            <!-- Check box-->
                                                            <div v-else-if="que_data.type == 'Checkbox' || que_data.type == 'check_box'" class="d-flex align-items-center flex-wrap">
                                                                <div v-for="(checkbox, checkbox_index) in que_data.possible_values" :key="checkbox_index">
                                                                    <div class="d-flex align-items-end mt-3">
                                                                        <el-checkbox :disabled="true" class="mb-0 mr-2"></el-checkbox>
                                                                        <input type="text" v-validate="selected_index == part_index ? 'required' : ''" maxlength="15" data-vv-as="Option" 
                                                                            :name="'checkbox_options'+all_questions_index+''+checkbox_index" :placeholder="'Option '+(checkbox_index+1)" 
                                                                            v-model="que_data.possible_values[checkbox_index]" class="input-border-bottom pb-0" @input="findDulplicatesoptions('multi_part', que_data)"
                                                                            style="width: 200px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                                                        <i :class="{'icon-delete-opacity-show':checkbox_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteMultiPartOptions(all_questions_index, checkbox_index, part_index)"></i>
                                                                        <i v-if="(que_data.possible_values.length - 1 == checkbox_index) && (que_data.possible_values.length < 50)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('checkbox_option', all_questions_index, checkbox_index, part_index)"></i>
                                                                    </div>
                                                                    <span class="invalid-feedback-form text-danger ml-3 position-absolute" v-show="errors.has('checkbox_options'+all_questions_index+''+checkbox_index)">{{errors.first('checkbox_options'+all_questions_index+''+checkbox_index)}}</span>
                                                                    <div class="text-right fs-14">{{15 - que_data.possible_values[checkbox_index].length}}/15</div>
                                                                </div>
                                                            </div>

                                                            <!-- Dropdown -->
                                                            <div v-else-if="que_data.type == 'Drop Down' || que_data.type == 'drop_down'" class="d-flex align-items-center flex-wrap">
                                                                <div v-for="(dropdown, dropdown_index) in que_data.possible_values" :key="dropdown_index" class="mt-3">
                                                                    <div class="d-flex align-items-end">
                                                                        <input type="text" v-validate="selected_index == part_index ? 'required' : ''" maxlength="15" data-vv-as="Option" @input="findDulplicatesoptions('multi_part', que_data)"
                                                                            :name="'dropdown_options'+all_questions_index+''+dropdown_index" :placeholder="'Option '+(dropdown_index+1)" 
                                                                            v-model="que_data.possible_values[dropdown_index]" class="input-border-bottom pb-0" 
                                                                            style="width: 228px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                                                        <i :class="{'icon-delete-opacity-show':dropdown_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteMultiPartOptions(all_questions_index, dropdown_index, part_index)"></i>
                                                                        <i v-if="(que_data.possible_values.length - 1 == dropdown_index) && (que_data.possible_values.length < 50)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('dropdown_option', all_questions_index, dropdown_index, part_index)"></i>
                                                                    </div>
                                                                    <span class="invalid-feedback-form text-danger ml-3 position-absolute" v-show="errors.has('dropdown_options'+all_questions_index+''+dropdown_index)">{{errors.first('dropdown_options'+all_questions_index+''+dropdown_index)}}</span>
                                                                    <div class="text-right fs-14">{{15 - que_data.possible_values[dropdown_index].length}}/15</div>
                                                                </div>
                                                            </div>
                                                            <!-- Short Answer -->
                                                            <div v-else-if="que_data.type == 'Short Answer' || que_data.type == 'short_answer'" class="mt-3">
                                                                <input type="text" readonly :name="'short_answer'+all_questions_index" placeholder="Short Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0" />
                                                            </div>
                                                            <!-- Long Answer -->
                                                            <div v-else-if="que_data.type == 'Long Answer' || que_data.type == 'long_answer'" class="mt-3">
                                                                <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="Long Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0" />
                                                                <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0 mt-3" />
                                                            </div>
                                                            <!-- Date -->
                                                            <div v-else-if="que_data.type == 'Date' || que_data.type == 'date'" class="mt-3">
                                                                <date-picker name="date"
                                                                    class="inputFieldNew-border-bottom date-picker-disabled" placeholder="MM/DD/YYYY"
                                                                    format="MM/DD/YYYY" type="date" lang="en"
                                                                    style="border:none !important" :disabled="true">
                                                                </date-picker>
                                                            </div>
                                                            <!-- Time -->
                                                            <div v-else-if="que_data.type == 'Time' || que_data.type == 'time'" class="mt-3">
                                                                <date-picker
                                                                    class="new-time-picker new-time-picker-icon input-field-underline date-picker-disabled date-picker-clock-icon mt-3"
                                                                    placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                                    type="time" format="HH/MM" :disabled="true">
                                                                </date-picker>
                                                            </div>
                                                            <!-- Date & Time -->
                                                            <div v-else-if="que_data.type == 'Date & Time'" class="mt-3">
                                                                <div class="d-flex align-items-center">
                                                                    <date-picker name="date"
                                                                        class="inputFieldNew-border-bottom date-picker-disabled" placeholder="MM/DD/YYYY"
                                                                        format="MM/DD/YYYY" type="date" lang="en"
                                                                        style="border:none !important" :disabled="true">
                                                                    </date-picker>
                                                                    <date-picker
                                                                        class="new-time-picker new-time-picker-icon input-field-underline date-picker-disabled date-picker-clock-icon"
                                                                        placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                                        type="time" format="HH/MM" :disabled="true">
                                                                    </date-picker>
                                                                </div>
                                                            </div>
                                                            <!-- Location -->
                                                            <div v-else-if="que_data.type == 'Location'" class="mt-3">
                                                                <div class="row">
                                                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                                                        <input type="text" readonly :name="'Location'+all_questions_index" placeholder="Location" style="border-bottom: solid 2px #0d84f2 !important; cursor: not-allowed" class="input-border-bottom pb-0" />
                                                                        <div class="d-flex">
                                                                            <i class="icon icon-map-marker color-blue" style="position: absolute;right: 10px;bottom: 5px;cursor: not-allowed"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-4 col-md-4 col-sm-12 mt-2">
                                                            <div class="d-flex align-items-center justify-content-end">
                                                                <span>
                                                                    Required
                                                                </span>
                                                                <span class="ml-2">
                                                                    <el-switch v-model="que_data.required">
                                                                    </el-switch>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-2" 
                                                            v-if="que_data.type == 'Radio Button' || que_data.type == 'radio_button' || 
                                                                    que_data.type == 'Checkbox' || que_data.type == 'check_box' || 
                                                                    que_data.type == 'Drop Down' || que_data.type == 'drop_down'">
                                                            <div class="d-flex align-items-center justify-content-start">
                                                                <span class="ml-2">
                                                                    <el-checkbox v-model="que_data.statement"></el-checkbox>
                                                                </span>
                                                                <span class="ml-2">
                                                                    Record a statement against the selected option
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="template-list-question-box-options" style="height: max-content; min-height: 116px;">
                                                    <div class="d-flex flex-column align-items-center" style="padding: inherit;">
                                                        <el-dropdown trigger="click" v-if="all_questions_index > 0">
                                                            <span class="el-dropdown-link">
                                                                <i class="icon icon-arrow-all pointer text-black"></i>
                                                            </span>
                                                            <el-dropdown-menu slot="dropdown">
                                                                <el-dropdown-item>
                                                                    <span v-if="all_questions_index > 0" class="d-flex align-items-center">
                                                                        <i class="icon icon-arrow-up" style="color: #303031 !important;font-size: 20px !important;"></i>
                                                                        <span @click="moveEntryMultiParts(all_questions_index, 'move_up', part_index)" class="fs-14">Move Above</span>
                                                                    </span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item>
                                                                    <span v-if="part.fields.length < 21 && part.fields.length - 1 != all_questions_index" class="d-flex align-items-center">
                                                                        <i class="icon icon-arrow-down" style="color: #303031 !important; font-size: 20px !important;"></i>
                                                                        <span class="fs-14" @click="moveEntryMultiParts(all_questions_index, 'move_down', part_index)">Move Down</span>
                                                                    </span>
                                                                </el-dropdown-item>
                                                            </el-dropdown-menu>
                                                        </el-dropdown>
                                                        <img class="mt-2 pointer" v-if="part.fields.length < 20" src="/static/images/new-theme2024/copy-multiple-blank-line.svg" @click="copyQuestion(all_questions_index, 'multi_part', part_index)" width="20" height="20" alt="copy" />
                                                        <img class="mt-2 pointer" v-else  src="/static/images/icon-awesome-copy-disabled.svg" width="20" height="20" alt="copy" />
                                                        <i v-if="part.fields.length <=1" class="icon ri-delete-bin-4-line mt-2" style="color: #707070; cursor: not-allowed;"></i>
                                                        <i v-else class="icon ri-delete-bin-4-line text-black mt-2 pointer" @click="deleteQuestion(all_questions_index, 'multi_part', part_index)"></i>
                                                        <i v-if="part.fields.length < 20 && part.fields.length-1 == all_questions_index" class="icon icon-plus-circle mt-2 pointer" @click="addNewQuestion('multi_part', part_index)" style="color: #388e3c;"></i>
                                                        <i v-else-if="part.fields.length-1 == all_questions_index" class="icon icon-plus-circle mt-2 pointer" style="color: #388e3c; cursor: not-allowed;"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-left text-danger mb-3 mt-5 w-100" v-if="que_data.is_duplicate">The Options must be Unique</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Default Part -->
                            <div class="mt-0" v-if="initial_template_data.template_type == 'default'">
                                <div v-for="(que_data, all_questions_index) in all_questions" :key="all_questions_index+'dd'">
                                    <div class="d-flex mt-3">
                                        <div class="template-list-question-box w-100">
                                            <div class="row d-flex flex-lg-row">
                                                <div class="col-lg-8 col-md-12 col-sm-12">
                                                    <div class="w-100" style="position: relative;">
                                                        <!-- @input="findDulplicatesquestions('default')" -->
                                                        <input class="newInputField inputFieldNew-padding" maxlength="200" v-validate="'required'" :name="'question'+all_questions_index" data-vv-as="Question"  v-model="que_data.name" type="text" autocomplete="off" placeholder="Enter Question" />
                                                        <span class="inputBorder"></span>
                                                        <span class="invalid-feedback-form text-danger mt-1 ml-3 position-absolute" v-show="errors.has('question'+all_questions_index)">{{errors.first('question'+all_questions_index)}}</span>
                                                        <span class="invalid-feedback-form text-danger mt-1 ml-3 position-absolute" :class="errors.has('question'+all_questions_index) ? 'top-57px' : ''" v-show="que_data.is_questions_duplicate">This Question must be Unique</span>
                                                        <div class="text-right fs-14 mt-1">{{200 - que_data.name.length}}/200</div>
                                                        <el-checkbox class="ml-2" @change="ToggleAttachment($event, que_data)" v-model="que_data.add_attachments">Add Attachments</el-checkbox>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="form-group contactGroup pt-2">
                                                        <div class="">
                                                            <multiselect
                                                                class="diginew-multiselect mt-1 multiSelectHeight down-arrow"
                                                                v-model="que_data.type"
                                                                :options="type_options"
                                                                :searchable="true"
                                                                :name="'type'+all_questions_index"
                                                                :close-on-select="true"
                                                                @close="watchFieldType(all_questions_index)"
                                                                v-validate="'required'"
                                                                :show-labels="false"
                                                                data-vv-as="Type"
                                                                placeholder="Choose Field Type"
                                                                internal-search="true"
                                                            >
                                                                <template slot="noResult">
                                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                </template>
                                                            </multiselect>
                                                        </div>
                                                        <span class="invalid-feedback-form text-danger mt-1" v-show="errors.has('type'+all_questions_index)">{{errors.first('type'+all_questions_index)}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row align-items-end">
                                                <div class="col-lg-8 col-md-8 col-sm-12">
                                                    <!-- Radio Button -->
                                                    <div v-if="que_data.type == 'Radio Button' || que_data.type == 'radio_button'" class="d-flex form-check form-check-inline">
                                                        <div v-for="(radio_btn, radio_btn_index) in que_data.possible_values" :key="radio_btn_index">
                                                            <label class="form-check-label position-relative mt-3 ml-5">
                                                                <input class="form-check-input" :disabled="true" style="top: 5px;left: -5px;width: 20px;height: 20px;" type="radio"
                                                                    value="option 1">
                                                                <span class="radio-icon" style="width: 20px;height: 20px;top: -4px;left: -20px;"></span>
                                                                <input type="text" maxlength="15" v-model="que_data.possible_values[radio_btn_index]" v-validate="'required'" @input="findDulplicatesoptions('default', que_data)"
                                                                    data-vv-as="Option" :name="'radio_options'+all_questions_index+''+radio_btn_index" :placeholder="'Option '+(radio_btn_index+1)" 
                                                                    class="input-border-bottom pb-0" style="width: 200px !important; border-bottom: solid 2px #0d84f2 !important;" />
                                                                <i :class="{'icon-delete-opacity-show':radio_btn_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteOptions(all_questions_index, radio_btn_index)"></i>
                                                                <i v-if="(que_data.possible_values.length - 1 == radio_btn_index) && (que_data.possible_values.length < 50)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('radio_btn_option', all_questions_index, radio_btn_index)"></i>
                                                            </label>
                                                            <span class="invalid-feedback-form text-danger ml-3 position-absolute" v-show="errors.has('radio_options'+all_questions_index+''+radio_btn_index)">{{errors.first('radio_options'+all_questions_index+''+radio_btn_index)}}</span>
                                                            <div class="text-right fs-14">{{15 - que_data.possible_values[radio_btn_index].length}}/15</div>
                                                        </div>
                                                    </div>

                                                    <!-- Check box-->
                                                    <div v-else-if="que_data.type == 'Checkbox' || que_data.type == 'check_box'" class="d-flex align-items-center flex-wrap">
                                                        <div v-for="(checkbox, checkbox_index) in que_data.possible_values" :key="checkbox_index">
                                                            <div class="d-flex align-items-end mt-3">
                                                                <el-checkbox :disabled="true" class="mb-0 mr-2"></el-checkbox>
                                                                <input type="text" v-validate="'required'" maxlength="15" data-vv-as="Option" :name="'checkbox_options'+all_questions_index+''+checkbox_index" @input="findDulplicatesoptions('default', que_data)"
                                                                    :placeholder="'Option '+(checkbox_index+1)" v-model="que_data.possible_values[checkbox_index]" class="input-border-bottom pb-0" 
                                                                    style="width: 200px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                                                <i :class="{'icon-delete-opacity-show':checkbox_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteOptions(all_questions_index, checkbox_index)"></i>
                                                                <i v-if="(que_data.possible_values.length - 1 == checkbox_index) && (que_data.possible_values.length < 50)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('checkbox_option', all_questions_index, checkbox_index)"></i>
                                                            </div>
                                                            <span class="invalid-feedback-form text-danger ml-3 position-absolute" v-show="errors.has('checkbox_options'+all_questions_index+''+checkbox_index)">{{errors.first('checkbox_options'+all_questions_index+''+checkbox_index)}}</span>
                                                            <div class="text-right fs-14">{{15 - que_data.possible_values[checkbox_index].length}}/15</div>
                                                        </div>
                                                    </div>

                                                    <!-- Dropdown -->
                                                    <div v-else-if="que_data.type == 'Drop Down' || que_data.type == 'drop_down'" class="d-flex align-items-center flex-wrap">
                                                        <div v-for="(dropdown, dropdown_index) in que_data.possible_values" :key="dropdown_index" class="mt-3">
                                                            <div class="d-flex align-items-end">
                                                                <input type="text" v-validate="'required'" maxlength="15" data-vv-as="Option" :name="'dropdown_options'+all_questions_index+''+dropdown_index" @input="findDulplicatesoptions('default', que_data)"
                                                                    :placeholder="'Option '+(dropdown_index+1)" v-model="que_data.possible_values[dropdown_index]" class="input-border-bottom pb-0" 
                                                                    style="width: 228px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                                                <i :class="{'icon-delete-opacity-show':dropdown_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteOptions(all_questions_index, dropdown_index)"></i>
                                                                <i v-if="(que_data.possible_values.length - 1 == dropdown_index) && (que_data.possible_values.length < 50)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('dropdown_option', all_questions_index, dropdown_index)"></i>
                                                            </div>
                                                            <span class="invalid-feedback-form text-danger ml-3 position-absolute" v-show="errors.has('dropdown_options'+all_questions_index+''+dropdown_index)">{{errors.first('dropdown_options'+all_questions_index+''+dropdown_index)}}</span>
                                                            <div class="text-right fs-14">{{15 - que_data.possible_values[dropdown_index].length}}/15</div>
                                                        </div>
                                                    </div>
                                                    <!-- Short Answer -->
                                                    <div v-else-if="que_data.type == 'Short Answer' || que_data.type == 'short_answer'" class="mt-3">
                                                        <input type="text" readonly :name="'short_answer'+all_questions_index" placeholder="Short Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0" />
                                                    </div>
                                                    <!-- Long Answer -->
                                                    <div v-else-if="que_data.type == 'Long Answer' || que_data.type == 'long_answer'" class="mt-3">
                                                        <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="Long Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0" />
                                                        <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0 mt-3" />
                                                    </div>
                                                    <!-- Date -->
                                                    <div v-else-if="que_data.type == 'Date' || que_data.type == 'date'" class="mt-3">
                                                        <date-picker name="date"
                                                            class="inputFieldNew-border-bottom date-picker-disabled" placeholder="MM/DD/YYYY"
                                                            format="MM/DD/YYYY" type="date" lang="en"
                                                            style="border:none !important" :disabled="true">
                                                        </date-picker>
                                                    </div>
                                                    <!-- Time -->
                                                    <div v-else-if="que_data.type == 'Time' || que_data.type == 'time'" class="mt-3">
                                                        <date-picker
                                                            class="new-time-picker new-time-picker-icon input-field-underline date-picker-disabled date-picker-clock-icon mt-3"
                                                            placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                            type="time" format="HH/MM" :disabled="true">
                                                        </date-picker>
                                                    </div>
                                                    <!-- Date & Time -->
                                                    <div v-else-if="que_data.type == 'Date & Time'" class="mt-3">
                                                        <div class="d-flex align-items-center">
                                                            <date-picker name="date"
                                                                class="inputFieldNew-border-bottom date-picker-disabled" placeholder="MM/DD/YYYY"
                                                                format="MM/DD/YYYY" type="date" lang="en"
                                                                style="border:none !important" :disabled="true">
                                                            </date-picker>
                                                            <date-picker
                                                                class="new-time-picker new-time-picker-icon input-field-underline date-picker-disabled date-picker-clock-icon"
                                                                placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                                type="time" format="HH/MM" :disabled="true">
                                                            </date-picker>
                                                        </div>
                                                    </div>
                                                    <!-- Location -->
                                                    <div v-else-if="que_data.type == 'Location'" class="mt-3">
                                                        <div class="row">
                                                            <div class="col-lg-4 col-md-6 col-sm-12">
                                                                <input type="text" readonly :name="'Location'+all_questions_index" placeholder="Location" style="border-bottom: solid 2px #0d84f2 !important; cursor: not-allowed" class="input-border-bottom pb-0" />
                                                                <div class="d-flex">
                                                                    <i class="icon icon-map-marker color-blue" style="position: absolute;right: 10px;bottom: 5px;cursor: not-allowed"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-12 mt-2">
                                                    <div class="d-flex align-items-center justify-content-end">
                                                        <span>
                                                            Required
                                                        </span>
                                                        <span class="ml-2">
                                                            <el-switch v-model="que_data.required">
                                                            </el-switch>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 col-md-12 col-sm-12 mt-2" 
                                                    v-if="que_data.type == 'Radio Button' || que_data.type == 'radio_button' || 
                                                            que_data.type == 'Checkbox' || que_data.type == 'check_box' || 
                                                            que_data.type == 'Drop Down' || que_data.type == 'drop_down'">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                        <span class="ml-2">
                                                            <el-checkbox v-model="que_data.statement"></el-checkbox>
                                                        </span>
                                                        <span class="ml-2">
                                                            Record a statement against the selected option
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="template-list-question-box-options" style="height: max-content; min-height: 116px;">
                                            <div class="d-flex flex-column align-items-center" style="padding: inherit;">
                                                <el-dropdown trigger="click" v-if="all_questions_index > 0">
                                                    <span class="el-dropdown-link">
                                                        <i class="icon icon-arrow-all pointer" style="color: #130e0e;"></i>
                                                    </span>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item>
                                                            <span v-if="all_questions_index > 0" class="d-flex align-items-center">
                                                                <i class="icon icon-arrow-up" style="color:#130e0e !important;font-size: 20px !important;"></i>
                                                                <span @click="moveEntry(all_questions_index, 'move_up')" class="fs-14">Move Above</span>
                                                            </span>
                                                        </el-dropdown-item>
                                                        <el-dropdown-item>
                                                            <span v-if="all_questions.length < 21 && all_questions.length - 1 != all_questions_index" class="d-flex align-items-center">
                                                                <i class="icon icon-arrow-down" style="color: #130e0e !important; font-size: 20px !important;"></i>
                                                                <span class="fs-14" @click="moveEntry(all_questions_index, 'move_down')">Move Down</span>
                                                            </span>
                                                        </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                                <img class="mt-2 pointer" v-if="all_questions.length < 20" src="/static/images/new-theme2024/copy-multiple-blank-fill.svg" @click="copyQuestion(all_questions_index, 'default')" width="20" height="20" alt="copy" />
                                                <img class="mt-2 pointer" v-else src="/static/images/new-theme2024/copy-multiple-blank-fill.svg" width="20" height="20" alt="copy" />
                                                <i v-if="all_questions.length <=1" class="icon ri-delete-bin-4-line mt-2" style="color: #707070; cursor: not-allowed;"></i>
                                                <i v-else class="icon ri-delete-bin-4-fill mt-2 pointer" @click="deleteQuestion(all_questions_index , 'default')" style="color: #130e0e;"></i>
                                                <i v-if="all_questions.length < 20 && all_questions.length-1 == all_questions_index" class="icon icon-plus-circle mt-2 pointer" @click="addNewQuestion('default')" style="color: #388e3c;"></i>
                                                <i v-else-if="all_questions.length-1 == all_questions_index" class="icon icon-plus-circle-outline mt-2 pointer" style="color: #130e0e; cursor: not-allowed;"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-left text-danger mb-3 mt-5 w-100" v-if="que_data.is_duplicate">The Options must be Unique</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between my-4" v-if="initial_template_data.template_type == 'default'">
                            <div></div>
                            <div>
                                <button type="button" class="btn btn-danger-new  " @click="goToListView" >Cancel</button>
                                <button type="button" class="btn btn-green  ml-4 text-white w-130px" :class="{'text-align-left' : save_loader, 'text-center' : !save_loader}" :disabled="save_loader" @click="createSuccess">
                                    {{ save_loader ? 'Saving' : 'Save' }}
                                    <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="position: absolute;right: 25px; top: 8px;"/>
                                </button>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between my-4" v-if="initial_template_data.template_type == 'multi_part'">
                            <div></div>
                            <div>
                                <button type="button" class="btn btn-danger-new  w-130px" @click="goToListView" v-if="selected_index == 0">Cancel</button>
                                <button type="button" class="btn btn-danger-new  w-130px" :disabled="save_loader" @click="navigateMultiPart('back')" v-if="selected_index > 0">
                                    <!-- <i class="icon icon-arrow-left text-secondary fs-15 mr-1"></i> -->
                                    Previous
                                </button>
                                <button type="button" class="btn btn-green text-capitalize ml-4 text-white w-130px" :class="{'text-align-left' : save_loader, 'text-center' : !save_loader}" v-if="selected_index == initial_template_data.multi_parts_data.length-1" :disabled="save_loader" @click="createMultiPartSuccess" >
                                    {{save_loader ? 'Saving' : 'Save'}}
                                    <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="position: absolute;right: 25px; top: 8px;" />
                                </button>
                                <button 
                                    type="button" class="btn btn-success text-capitalize ml-4 text-white w-130px" :disabled="multipartSelectedArray.some(x => x.is_duplicate == true) || multipartSelectedArray.some(x => x.is_questions_duplicate == true) || multipartSelectedArray.some(x => x.name == '') || multipartSelectedArray.some(x => x.type == '')"
                                    @click="navigateMultiPart('front')" v-if="selected_index != initial_template_data.multi_parts_data.length-1">Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import dynamic_template from '../../mixins/dynamic_template.js'
export default {
    mixins: [dynamic_template],
    components: {
        SweetModal,
        HalfCircleSpinner
    },
    data() {
        return {

            success_msg:'',
            warning_msg:'',
            template_name: "",
            ajax_call_in_progress: false,
            limit: 10,
            skip: 0,
            isVisible: false,
            type_options: ['Checkbox', 'Date', 'Date & Time', 'Drop Down', 'Location', 'Long Answer', 'Radio Button', 'Short Answer', 'Tag', 'Time'],
            search_key: '',
            dropdown_loading: false,
            scrollable: false,
            is_api_calling: false,
            save_loader: false,
            all_questions: [{
                add_attachments: false,
                required: false,
                type: '',
                name: '',
                possible_values: ['', ''],
                statement: false,
                is_duplicate: false,
                is_questions_duplicate: false
            }],
            initial_template_data: '',
            selected_index: 0
        }
    },
    methods: {
        findDulplicatesquestions(template_type){
            if(template_type == 'multi_part'){
                let temp_questions = this.initial_template_data.multi_parts_data[this.selected_index].fields.map(x => x.name)
                this.initial_template_data.multi_parts_data[this.selected_index].fields.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            } else {
                let temp_questions = this.all_questions.map(x => x.name)
                // this.all_questions.forEach((x) => {
                //     x.is_questions_duplicate = temp_questions.some((item, idx) => {
                //         return temp_questions.indexOf(item) != idx 
                //     })
                // })
                this.all_questions.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            }
        },
        findDulplicatesoptions(template_type, data){
            if(template_type == 'multi_part'){
                data.is_duplicate = data.possible_values.some((item, idx) => {
                    return data.possible_values.indexOf(item) != idx 
                })
            } else {
                data.is_duplicate = data.possible_values.some((item, idx) => {
                    return data.possible_values.indexOf(item) != idx 
                })
                // data.is_questions_duplicate = this.all_questions.some((item, idx) => {
                //     return this.all_questions.indexOf(item.name) != idx 
                // })
            }
        },
        navigateMultiPart(type){
            if(type == 'back' && this.selected_index > 0){
                if(this.save_loader){
                    this.save_loader = false
                }
                this.selected_index -= 1 
            } 
            if(type == 'front' && this.selected_index < this.initial_template_data.multi_parts_data.length-1){
                // For Answers
                let duplicates_validated = this.initial_template_data.multi_parts_data[this.selected_index].fields.every(x => x.is_duplicate == false)
                // For Questions
                let questions_duplicates_validated = this.initial_template_data.multi_parts_data[this.selected_index].fields.every(x => x.is_questions_duplicate == false)
                this.$validator.validateAll().then(result => {
                    if(result && duplicates_validated && questions_duplicates_validated){
                        this.selected_index += 1 
                    }
                })
            }
            this.$forceUpdate()
        },
        goToTemplateList() {
            this.$router.push('/settings?type=templatesnew')
        },
        deleteOptions(parent_index, index) {
            this.all_questions[parent_index].possible_values.splice(index, 1)
        },
        deleteMultiPartOptions(parent_index, index, part_index) {
            this.initial_template_data.multi_parts_data[part_index].fields[parent_index].possible_values.splice(index, 1)
        },
        addOptions(type, parent_index, index, part_index) {
            if(this.initial_template_data.template_type == 'default'){
                this.all_questions[parent_index].possible_values.push('')
            } else {
                this.initial_template_data.multi_parts_data[part_index].fields[parent_index].possible_values.push('')
            }
        },
        addNewQuestion(template_type, index) {
            if(template_type == 'default'){
                this.all_questions.push(
                    {
                        required: false,
                        type: '',
                        name: '',
                        possible_values: ['', ''],
                        statement: false,
                        add_attachments: false,
                        is_duplicate: false,
                        is_questions_duplicate:false
                    }
                );
            } else {
                this.initial_template_data.multi_parts_data[index].fields.push({
                    required: false,
                    type: '',
                    name: '',
                    possible_values: ['', ''],
                    statement: false,
                    add_attachments: false,
                    is_duplicate: false,
                    is_questions_duplicate:false
                })
            }
        },
        deleteQuestion(index, template_type, part_index) {
            if(template_type == 'default'){
                this.all_questions.splice(index, 1)
                // check for duplicate questions
                let temp_questions = this.all_questions.map(x => x.name)
                // this.all_questions.forEach((x) => {
                //     x.is_questions_duplicate = temp_questions.some((item, idx) => {
                //         return temp_questions.indexOf(item) != idx 
                //     })
                // })
                this.all_questions.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            } else {
                this.initial_template_data.multi_parts_data[part_index].fields.splice(index, 1)
                // check for duplicate questions
                let temp_questions = this.initial_template_data.multi_parts_data[this.selected_index].fields.map(x => x.name)
                this.initial_template_data.multi_parts_data[this.selected_index].fields.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            }
        },
        copyQuestion(index, template_type, part_index) {
            if(template_type == 'default'){
                this.all_questions.splice(index, 0, JSON.parse(JSON.stringify(this.all_questions[index])))
                this.all_questions[index+1].name = ''
                // check for duplicate questions
                let temp_questions = this.all_questions.map(x => x.name)
                // this.all_questions.forEach((x) => {
                //     x.is_questions_duplicate = temp_questions.some((item, idx) => {
                //         return temp_questions.indexOf(item) != idx 
                //     })
                // })
                this.all_questions.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            } else {
                this.initial_template_data.multi_parts_data[part_index].fields.splice(index, 0, JSON.parse(JSON.stringify(this.initial_template_data.multi_parts_data[part_index].fields[index])))
                this.initial_template_data.multi_parts_data[part_index].fields[index+1].name = ''
                // check for duplicate questions
                let temp_questions = this.initial_template_data.multi_parts_data[this.selected_index].fields.map(x => x.name)
                this.initial_template_data.multi_parts_data[this.selected_index].fields.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            }
        },
        moveEntryMultiParts(index, type, part_index){
            switch (type) {
                case 'move_up':
                    let element_up = this.initial_template_data.multi_parts_data[part_index].fields[index]
                    this.initial_template_data.multi_parts_data[part_index].fields.splice(index, 1);
                    this.initial_template_data.multi_parts_data[part_index].fields.splice(index-1, 0, element_up);
                    break;
                case 'move_down':
                    let element_down = this.initial_template_data.multi_parts_data[part_index].fields[index];
                    this.initial_template_data.multi_parts_data[part_index].fields.splice(index, 1);
                    this.initial_template_data.multi_parts_data[part_index].fields.splice(index+1, 0, element_down);
                    break;
            }
        },
        moveEntry(index, type) {
            switch (type) {
                case 'move_up':
                    let element_up = this.all_questions[index];
                    this.all_questions.splice(index, 1);
                    this.all_questions.splice(index-1, 0, element_up);
                    break;
                case 'move_down':
                    let element_down = this.all_questions[index];
                    this.all_questions.splice(index, 1);
                    this.all_questions.splice(index+1, 0, element_down);
                    break;
            }
        },
        goToListView() {
            if(this.initial_template_data.template_type == 'default'){
                this.initial_template_data.template_data = this.all_questions
            }
            localStorage.setItem('storedTemplateData', JSON.stringify(this.initial_template_data))
            this.$router.push({
                path:'/settings',
                query: {
                    type:'templatesnew',
                    call_type:'redirection_mode'
                }
            })
        },
        watchFieldType(index){
            if(this.all_questions[index].type == 'Drop Down' || this.all_questions[index].type == 'Checkbox' || this.all_questions[index].type == 'Radio Button'){
                if(!this.all_questions[index].hasOwnProperty('statement')){
                    this.all_questions[index].statement = false
                }
            } else {
                if(this.all_questions[index].hasOwnProperty('statement')){
                    delete this.all_questions[index].statement
                }
            }
        },
        createMultiPartSuccess(){
            localStorage.setItem('dynamic_template_data', JSON.stringify(this.createMP_data));
            let filtered_data = JSON.parse(localStorage.getItem('dynamic_template_data'));
            let duplicates_validated = this.initial_template_data.multi_parts_data[this.selected_index].fields.every(x => x.is_duplicate == false)
            let duplicate_questions_validated = this.initial_template_data.multi_parts_data[this.selected_index].fields.every(x => x.is_questions_duplicate == false)
            filtered_data.multi_parts_data.forEach((el) => {
                el.fields.forEach((data, index) => {
                    let uniqueArray
                    switch (data.type) {
                        case 'Radio Button' || 'radio_button':
                            data.type = 'radio_button';
                            uniqueArray = data.possible_values.filter((value, index_radio) => {
                                const _value = JSON.stringify(value);
                                return index_radio === data.possible_values.findIndex(obj => {
                                    return JSON.stringify(obj) === _value;
                                });
                            });
                            data.possible_values = uniqueArray
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Checkbox' || 'check_box':
                            data.type = 'check_box';
                            uniqueArray = data.possible_values.filter((value, index_check) => {
                                const _value = JSON.stringify(value);
                                return index_check === data.possible_values.findIndex(obj => {
                                    return JSON.stringify(obj) === _value;
                                });
                            });
                            data.possible_values = uniqueArray
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Drop Down' || 'drop_down':
                            data.type = 'drop_down';
                            uniqueArray = data.possible_values.filter((value, index_dd) => {
                                const _value = JSON.stringify(value);
                                return index_dd === data.possible_values.findIndex(obj => {
                                    return JSON.stringify(obj) === _value;
                                });
                            });
                            data.possible_values = uniqueArray
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Short Answer' || 'short_answer':
                            data.type = 'short_answer';
                            delete el.fields[index].possible_values;
                            delete el.fields[index].statement
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Long Answer' || 'long_answer':
                            data.type = 'long_answer';
                            delete el.fields[index].possible_values;
                            delete el.fields[index].statement
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Date' || 'date':
                            data.type = 'date';
                            delete el.fields[index].possible_values;
                            delete el.fields[index].statement
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Time' || 'time':
                            data.type = 'time';
                            delete el.fields[index].possible_values;
                            delete el.fields[index].statement
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Date & Time':
                            data.type = 'date_time';
                            delete el.fields[index].possible_values;
                            delete el.fields[index].statement
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Tag' || 'tag':
                            data.type = 'tag';
                            delete el.fields[index].possible_values;
                            delete el.fields[index].statement
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                        case 'Location':
                            data.type = 'location';
                            delete el.fields[index].possible_values;
                            delete el.fields[index].statement
                            delete data.is_duplicate;
                            delete data.is_questions_duplicate
                            break;
                    }
                })
            })
            this.$validator.validateAll().then(async result => {
                if(result && duplicates_validated && duplicate_questions_validated){
                    this.confirmMultiPart(filtered_data)
                }
            })
        },
        async confirmMultiPart(payload){
            this.$validator.validateAll().then(async result => {
                if(result){
                    this.save_loader = true
                    try{    
                        // this.is_api_calling = true
                        if(this.$route.path.startsWith('/dynamictemplate/edit')){
                            payload.dynamic_template_id = this.$route.params.id
                            var response = await this.editDynamicTemplate(payload)
                        } else {
                            var response = await this.createDynamicTemplate(payload)
                        }
                        if(response.status_id == 1){
                            if(response.response.hasOwnProperty('success_message')){
                                this.success_msg = response.response.success_message;
                            } else {
                                this.success_msg = response.response;
                            }
                            this.$refs.success_modal.open()
                            setTimeout(() => {
                                this.$refs.success_modal.close()
                                localStorage.removeItem('dynamic_template_data')
                                localStorage.removeItem('storedTemplateData')
                                this.is_api_calling = false
                                if(this.$route.path.startsWith('/dynamictemplate/edit')){
                                    this.$router.replace('/dynamictemplate/view/'+this.$route.params.id);
                                } else{
                                    this.$router.replace('/dynamictemplate/view/'+response.response.dynamic_template_id);
                                }
                            }, 2000);
                        } else {
                            this.save_loader = false
                            // this.is_api_calling = false
                            this.success_msg = response.reason;
                            this.$refs.warning_modal.open()
                            setTimeout(() => {
                                this.$refs.warning_modal.close()
                            }, 2000);
                        }
                    } catch(err) {
                        this.save_loader = false
                        // this.is_api_calling = false
                        this.success_msg = err;
                        this.$refs.warning_modal.open()
                        setTimeout(() => {
                            this.$refs.warning_modal.close()
                        }, 2000);
                    }
                }
            })
        },
        ToggleAttachment(event, data){
            data.add_attachments = event
            this.$forceUpdate()
        },
        async createSuccess() {
            localStorage.setItem('dynamic_template_data', JSON.stringify(this.create_data));
            let filtered_data = JSON.parse(localStorage.getItem('dynamic_template_data'));
            let duplicates_validated = this.all_questions.every(x => x.is_duplicate == false)
            let duplicate_questions_validated = this.all_questions.every(x => x.is_questions_duplicate == false)
            filtered_data.fields.forEach((data, index) => {
                let uniqueArray
                switch (data.type) {
                    case 'Radio Button' || 'radio_button':
                        data.type = 'radio_button';
                        uniqueArray = data.possible_values.filter((value, index_radio) => {
                            const _value = JSON.stringify(value);
                            return index_radio === data.possible_values.findIndex(obj => {
                                return JSON.stringify(obj) === _value;
                            });
                        });
                        data.possible_values = uniqueArray
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Checkbox' || 'check_box':
                        data.type = 'check_box';
                        uniqueArray = data.possible_values.filter((value, index_check) => {
                            const _value = JSON.stringify(value);
                            return index_check === data.possible_values.findIndex(obj => {
                                return JSON.stringify(obj) === _value;
                            });
                        });
                        data.possible_values = uniqueArray
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Drop Down' || 'drop_down':
                        data.type = 'drop_down';
                        uniqueArray = data.possible_values.filter((value, index_dd) => {
                            const _value = JSON.stringify(value);
                            return index_dd === data.possible_values.findIndex(obj => {
                                return JSON.stringify(obj) === _value;
                            });
                        });
                        data.possible_values = uniqueArray
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Short Answer' || 'short_answer':
                        data.type = 'short_answer';
                        delete filtered_data.fields[index].possible_values;
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Long Answer' || 'long_answer':
                        data.type = 'long_answer';
                        delete filtered_data.fields[index].possible_values;
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Date' || 'date':
                        data.type = 'date';
                        delete filtered_data.fields[index].possible_values;
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Time' || 'time':
                        data.type = 'time';
                        delete filtered_data.fields[index].possible_values;
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Date & Time':
                        data.type = 'date_time';
                        delete filtered_data.fields[index].possible_values;
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Tag' || 'tag':
                        data.type = 'tag';
                        delete filtered_data.fields[index].possible_values;
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                    case 'Location':
                        data.type = 'location';
                        delete filtered_data.fields[index].possible_values;
                        delete data.is_duplicate;
                        delete data.is_questions_duplicate;
                        break;
                }
            })
            this.$validator.validateAll().then(async result => {
                if (result && duplicates_validated && duplicate_questions_validated) {
                    this.reached_validator = true
                    if(this.$route.path.startsWith('/dynamictemplate/edit')) {
                        filtered_data.dynamic_template_id = this.$route.params.id;
                        this.saveDataEdit(filtered_data);
                    } else {
                        this.saveDataCreate(filtered_data);
                    }
                } else {

                }
            });
        },
        async saveDataCreate(data) {
            // this.is_api_calling = true;
            this.save_loader = false
            try {
                let params = data;
                let response = await this.createDynamicTemplate(params);
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    localStorage.removeItem('dynamic_template_data')
                    if(this.$route.path.startsWith('/dynamictemplate/create')) {
                        this.$router.replace('/dynamictemplate/view/'+response.response.dynamic_template_id);
                    }
                    // this.is_api_calling = false
                    this.save_loader = false
                    // this.goToTemplateList();
                }, 3000);
            }
            catch(err) {
                this.save_loader = false
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                this.is_api_calling = false;
            }
        },
        async saveDataEdit(data) {
            this.save_loader = true
            // this.is_api_calling = true;
            try {
                let params = data;
                let response = await this.editDynamicTemplate(params);
                this.success_msg = response.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    localStorage.removeItem('dynamic_template_data')
                    if(this.$route.path.startsWith('/dynamictemplate/edit')) {
                        this.$router.replace('/dynamictemplate/view/'+this.$route.params.id);
                    }
                    // this.is_api_calling = false
                    this.save_loader = false
                    // this.goToTemplateList();
                }, 3000);
            }
            catch(err) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                this.save_loader = false
                // this.is_api_calling = false;
            }
        },
        async getTemplateDataById(id) {
            this.ajax_call_in_progress = true;
            this.is_api_calling = true
            try {
                let param = {
                    dynamic_template_id: id
                };
                let response = await this.getDynamicTemplate(param);
                this.all_questions = response.response.fields;
                this.template_name = response.response.name;
                this.ajax_call_in_progress = false;
                this.all_questions.forEach((data, index) => {
                switch (data.type) {
                    case 'radio_button':
                        data.type = 'Radio Button';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'check_box':
                        data.type = 'Checkbox';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'drop_down':
                        data.type = 'Drop Down';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'short_answer':
                        data.type = 'Short Answer';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'long_answer':
                        data.type = 'Long Answer';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'date':
                        data.type = 'Date';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'date_time':
                        data.type = 'Date & Time';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'time':
                        data.type = 'Time';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'tag':
                        data.type = 'Tag';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'location':
                        data.type = 'Location';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                }
            })
            this.is_api_calling = false
            }
            catch(err) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                this.is_api_calling = false;
            }
        },
        multiPartsDataChanges(){
            if(this.initial_template_data.template_type == 'default'){
                this.initial_template_data.template_data.forEach((el) => {
                    el.is_duplicate = false
                    el.is_questions_duplicate = false
                    if(!el.hasOwnProperty('add_attachments')){
                        el.add_attachments = false
                    }
                })
                this.all_questions = this.initial_template_data.template_data
                this.all_questions.forEach((data, index) => {
                switch (data.type) {
                    case 'radio_button':
                        data.type = 'Radio Button';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'check_box':
                        data.type = 'Checkbox';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'drop_down':
                        data.type = 'Drop Down';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'short_answer':
                        data.type = 'Short Answer';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'long_answer':
                        data.type = 'Long Answer';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'date':
                        data.type = 'Date';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'date_time':
                        data.type = 'Date & Time';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'time':
                        data.type = 'Time';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'tag':
                        data.type = 'Tag';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'location':
                        data.type = 'Location';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    }
                })
                let temp_questions = this.all_questions.map(x => x.name)
                // this.all_questions.forEach((x) => {
                //     x.is_questions_duplicate = temp_questions.some((item, idx) => {
                //         return temp_questions.indexOf(item) != idx 
                //     })
                // })
                this.all_questions.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            } else {
                this.initial_template_data.multi_parts_data.forEach((el) => {
                    el.fields.forEach((x) => {
                        x.is_duplicate = false
                        x.is_questions_duplicate = false
                        if(!x.hasOwnProperty('add_attachments')){
                            x.add_attachments = false
                        }
                    })
                })
                this.$forceUpdate()
                this.initial_template_data.multi_parts_data.forEach((el) => {
                    el.fields.forEach((x) => {
                        switch (x.type) {
                            case 'radio_button':
                                x.type = 'Radio Button';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'check_box':
                                x.type = 'Checkbox';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'drop_down':
                                x.type = 'Drop Down';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'short_answer':
                                x.type = 'Short Answer';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'long_answer':
                                x.type = 'Long Answer';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'date':
                                x.type = 'Date';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'date_time':
                                x.type = 'Date & Time';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'time':
                                x.type = 'Time';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'tag':
                                x.type = 'Tag';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                            case 'location':
                                x.type = 'Location';
                                if(x.possible_values) {
                                } else {
                                    x.possible_values = ['', '']
                                }
                                break;
                        }
                    })
                })
                // check for duplicate questions
                let temp_questions = this.initial_template_data.multi_parts_data[this.selected_index].fields.map(x => x.name)
                this.initial_template_data.multi_parts_data[this.selected_index].fields.forEach((x, x_index) => {
                    x.is_questions_duplicate = temp_questions.indexOf(x.name) != x_index
                })
            }   
        }
    },
    mounted() {
        // if(this.$route.path.startsWith('/dynamictemplate/edit')) {
        //     this.getTemplateDataById(this.$route.params.id);
        // }
    },
    computed: {
        create_data() {
            return {
                name: this.initial_template_data.name,
                fields: this.all_questions,
                template_type: this.initial_template_data.template_type,
                approve_data: []
            }
        },
        createMP_data() {
            return {
                name: this.initial_template_data.name,
                template_type: this.initial_template_data.template_type,
                number_of_parts: this.initial_template_data.number_of_parts,
                multi_parts_data: this.initial_template_data.multi_parts_data,
                approve_data: this.initial_template_data.approve_data.map(x => x.id)
            }
        },
        multipartSelectedArray(){
            if(this.initial_template_data.template_type == 'multi_part'){
                return this.initial_template_data.multi_parts_data[this.selected_index].fields
            }
        }
    },
    created(){
        this.initial_template_data = JSON.parse(localStorage.getItem('storedTemplateData')) 
        if(this.initial_template_data.template_type == 'default' && this.initial_template_data.template_data.length != 0){
            this.all_questions = this.initial_template_data.template_data
        }
        if(this.$route.path.startsWith('/dynamictemplate/edit')){
            this.multiPartsDataChanges()
        }
        const dict = {
            custom: {
                template_name:{
                    required:() => "Template name is Required",
                },
            }
        }
        this.$validator.localize("en", dict);
    }
}
</script>
<style scoped>
.parts-container {
    display: flex;
    flex-wrap: wrap; 
}

.part-item {
    flex: 1 1 30%; 
    margin-right: 1.66%; 
    box-sizing: border-box;
    max-width: 30%; 
}



.index-circle {
    display: inline-block;
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background-color: transparent;
    border: 0.5px solid #130e0e;
    color: #130e0e;
    text-align: center;
    line-height: 19px;
    font-size: 13px;
}

.selected {
    background-color: #00f; /* Blue color */
    color: #fff; /* White color */
}

.newInputField {
    font-size: 14px !important;
    padding: 10px 18px 7px 9px !important;
    display: block;
    width: 100%;
    border: none;
    background: transparent !important;
    color: #303031;
    font-weight: 600;
    border-radius: 5px !important;
    margin-top: 12px;
    background-color: #f1f1f1 !important;
}
.text-new-blue{
    color: #00448b;
}
    .template-list-main-container {
        padding: 0px;
        border-radius: 6px;
        /* background-color: #fff; */
    }
    .template-list-main-container-inner {
        padding: 10px 0 10px 0;
        border-radius: 6px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
    }
    .template-list-header {
        margin: 0 0 14.2px;
        padding: 9.7px 35.5px;
        background-color: #005dae;
    }
    .template-list-inner-content {
        padding: 20px 20px;
    }
    .template-list-inner-content .row {
        margin-left: -15px !important;
        margin-right: -15px !important;
    }
    .template-list-question-box {
        padding: 12px 18.5px 12px 21.5px;
        box-shadow: 0 0 2px 0 #939393;
        border-radius: 5px;
        /* border: solid 0.3px #6c6d6f; */
        background-color: #fff;
        border: solid 0.3px #0d84f2 !important;

    }
    .input-border-bottom {
        border: 0 !important;
        padding: 5px 8px;
        padding-left: 0;
        width: 100% !important;
        border-bottom: solid 1px #707070 !important;
    }
    .icon-delete-opacity-hide {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
    }
    .icon-delete-opacity-show {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }
    .template-list-question-box-options {
        padding: 5.6px 4px 5.5px 1.8px;
        border-radius: 1px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.33);
        background-color: #fff;

    }
    .message-icon .message-content{
        width:30px;
        height:30px;
        /* background:#00448b !important; */
        border-radius: 3px;
        color:#fff;
        margin: auto;
    }
    .message-icon .message-arrow{
        width:10px;
        height:10px;
        /* background:#00448b !important; */
        transform: rotate(45deg);
        position: relative;
        bottom:5px;
        left:45px
    }
    .message-icon .message-name{
        width: 100px;
        text-align: center;
        overflow: hidden;
        word-break: break-all;
    }
    .position-relative{
        position: relative;
    }
    .bg-grey{
        background-color: #939393!important;
    }
    .color-grey{
        color: #939393!important;
    }
    .color-secondary{
        color: #00448b !important;
        /* border-bottom: 2px solid #00448b; */
        width: 50%;

    }
    .color-success{
        color: #4CAF50 !important;
    }
    .bg-secondary-custom{
        background-color: #00448b !important;
        color: white !important;
    }
    .bg-grey-custom{
        background-color: #939393 !important;
        color: white !important;
    }
    .bg-success-custom{
        background-color: #4CAF50 !important;
        color: white !important;
    }
    .w-130px{
        width: 130px !important
    }
    .btn-secondary-outline{
        border-radius: 4px;
        border: solid 0.5px #F44336;
        background-color: #fff;
        color: #F44336;
    }
    .btn-secondary-outline:hover{
        background-color: #F44336;
        color: #fff;
    }
    .btn-success{
        background-color: #41ae5d;
    }
    .bg-success{
        background-color: #41ae5d;
    }
    .overflow-auto{
        overflow: auto !important;
    }
    .custom-width{
        width: 235px !important;
    }
    .left-15px{
        left: 15% !important
    }
    .left-5px{
        left: 5% !important
    }
    .padding-custom{
        padding-right: 160px
    }
    @media screen and (max-width:685px) {
        .custom-width{
            width: 140px !important;
        }
        .padding-custom{
            padding-right: 60px
        }
    }
    .position-absolute{
        position: absolute !important;
    }
    .top-57px{
        top: 57px !important;
    }
    .text-align-left{
        text-align: left !important;
    }
    .w-100px{
        width: 100px !important
    }
    div.caps::first-letter{
        text-transform: uppercase !important;
    }
    .breadcrumbnewtheme{
        display: flex;
        align-items: center;
        gap: 1rem;
        border-bottom: 2px solid #636e71;
    }
    .breadcrumbnewtheme div{
        color: #00448b;
    }
    .fs-2rem{
        font-size: 2rem;
    }
    .position-content-main{
        /* height: 800px; */
        border-radius: 14px;
        background-color: #f0ddb7;
    }
    .header-color{
        color: #4e4e4e !important;
    }
    .color-light-blue{
        color: #0066d0;
    }
</style>